import {Dialog, DialogActions, DialogContent, Grid, Typography} from "@material-ui/core"
import React from "react"
import {injectIntl} from "react-intl"
import XsButton from "../../global/ui/xsButton/xsButton"
import GlobalStore from "../../global/store/GlobalStore"
import {observer} from "mobx-react"

function ConfirmRegistrationDialog() {
	return (
		<Dialog
			id="confirmRegistrationDialogOpened"
			open={GlobalStore.confirmRegistrationDialogOpened}
			onClose={() => GlobalStore.closeConfirmRegistrationDialog()}
			className="xs-base-dialog"
			classes={{
				paper: "xs-paper-dialog xs-width-paper-900 fullWidth"
			}}
			disableBackdropClick={true}
			maxWidth="sm"
		>
			<DialogContent>
				<Grid item container direction="column" xs={12} className="mt-1 mb-3" spacing={2}>
					<Grid item>
						<Typography variant="body1" className="bold">
							Registrácia prebehla úspešne.
						</Typography>
					</Grid>
					<Grid item>
						<Typography variant="body2">
							Na Vami zadanú emailovú adresu Vám boli zaslané inštrukcie pre úspešné dokončenie registrácie do portálu
							Zelená podnikom (odosielateľ: info@zelenapodnikom.sk).
						</Typography>
					</Grid>
					<Grid item>
						<Typography variant="body2">
							V prípade, že uvedený email vo Vašej emailovej schránke nevidíte, prosím skontrolujte priečinok SPAM
							(alebo podobné).
						</Typography>
					</Grid>
					<Grid item>
						<Typography variant="body2">Dokončenie registrácie je potrebné vykonať do 72 hodín.</Typography>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Grid item container justify="flex-end" className="mr-2 mb-2">
					<Grid item>
						<XsButton
							className="xs-success"
							icon={<i className="fal fa-check" />}
							text="OK"
							onClick={() => GlobalStore.closeConfirmRegistrationDialog()}
						/>
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	)
}

export default injectIntl(observer(ConfirmRegistrationDialog))

